import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "product_prices",
    object: "product_price",
    header: [
      { text: "ID", value: "id" },
      { text: "Picture", value: "picture" },
      { text: "Region", value: "region_id" },
      { text: "Name", value: "name" },
      { text: "Sku", value: "sku" },
      { text: "Final price", value: "final_price" },
      /* { text: "Actions", value: "actions", sortable: false }, */
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
